export const SidebarDynamicRules = [
  {
    target: "sezInfo",
    property: "disabled",
    dependsOn: ["general.exportSBType" , "general.exporterJobNumber"],
    condition: (exportSBType, exportJobNumber) => {
      // Disable if exportSBType is undefined, null, empty, or one of these colors
      if (!exportSBType) return true;
      return ["white", "green", "yellow", "blue", "pink"].includes(exportSBType) && exportJobNumber; ;
    },
  },
  {
    target: "container",
    property: "disabled",
    dependsOn: ["general.exportTransportMode","general.exporterJobNumber"],
    condition: (exportTransportMode, exportJobNumber) => {
      // Disable if exportSBType is undefined, null, empty, or one of these colors
      if (!exportTransportMode) return true;
      return (exportTransportMode == 'air') && exportJobNumber;
    },
  },
];
